import { render } from "./TextJudgement.vue?vue&type=template&id=01ad3145"
import script from "./TextJudgement.vue?vue&type=script&lang=js"
export * from "./TextJudgement.vue?vue&type=script&lang=js"

import "./TextJudgement.vue?vue&type=style&index=0&id=01ad3145&lang=scss"
script.render = render

export default script